import React from 'react'

const RequriedText = ({ label }) => {
    return (
    <div><span className="required-text">*</span> { label }</div>
    )
}

export default RequriedText
